import { saveUserSignature, saveUserSignatureFailure, saveUserSignatureSuccess } from './../onboarding/onboarding.actions';
import { SpokenLanguageModel, UserTypeModel } from './../../../models/userProfileModel';
import { ValidatorRequiredIfBool, ValidatorConfirmField, ValidatorRequiredTrueIfBool, ValidatorRequiredNotEmptyIfBool, ValidatorRequiredArrayNotEmptyOrTrue } from 'src/app/helpers/validators';
import { UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { UserProfileModel, RenderingProviderModel, RaceEthnicityModel, JobTitleModel, MaritalStatusModel, StatutoryClassModel, AcaClassificationModel, EeoJobCategoryModel } from '../../../models/userProfileModel';
import {
  loadProfile, loadProfileSuccess, saveProfileSuccess,
  updateProfileForm, getPhotoSuccess, uploadPhoto, uploadPhotoSuccess, changePassword, getReturnEquipmentAlerts, getReturnEquipmentAlertsSuccess,
  changePasswordSuccess, updateProfileBCIForm, saveProfile, saveProfileFail, updateProfileCBSForm,
    updateProfilePRISMForm, updateProfileI9Form, loadRaceOptionsSuccess, loadJobTitlesSuccess, loadProfileOptionsSuccess, loadUserTypes, loadUserTypesSuccess, saveSignature, saveSignatureFailure, saveSignatureSuccess, updateProfileW4Form, loadSpokenLanguageOptionsSuccess
} from './profile.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { State } from '../';
import { getAllControlsErrors, formatPhoneNumber } from 'src/app/helpers/utils';
import { FormError } from 'src/app/models/utilModels';

export interface ProfileState {
  profile: UserProfileModel;
  formErrors: FormError[];
  photoUrl: string;
  uploadingPhoto: boolean;
  changingPassword: boolean;
  savingProfile: boolean;
  raceOptions: RaceEthnicityModel[];
  jobTitles: JobTitleModel[];
  maritalStatusOptions: MaritalStatusModel[];
  statutoryClassOptions: StatutoryClassModel[];
  eeoJobCategoryOptions: EeoJobCategoryModel[];
  acaClassificationOptions: AcaClassificationModel[];
  userTypes: UserTypeModel[];
  savingSignature: boolean;
  spokenLanguageOptions: SpokenLanguageModel[];
  returnEquipmentAlert: string;
  returnEquipmentAlertCount: number;
  returnEquipmentAlertAllCount: number;
  fb: UntypedFormBuilder;
}

const initialState: ProfileState = {
  profile: null,
  formErrors: null,
  photoUrl: '',
  uploadingPhoto: false,
  changingPassword: false,
  savingProfile: false,
  raceOptions: [],
  jobTitles: [],
  maritalStatusOptions: [],
  statutoryClassOptions: [],
  eeoJobCategoryOptions: [],
  acaClassificationOptions: [],
  userTypes: [],
  savingSignature: false,
  spokenLanguageOptions: [],
  returnEquipmentAlert: "",
  returnEquipmentAlertCount: 0,
  returnEquipmentAlertAllCount: 0,
  fb: new UntypedFormBuilder
};

export const profileReducer = createReducer(initialState,
  on(loadProfile, (state, action) => ({ ...state })),
  on(loadProfileSuccess, (state, action) => {
    let formErrors;
    if (action.profile.employee) {
      const form = initProfileForm(action.profile, state.fb);
      formErrors = getAllControlsErrors(form);
    }
    return {
      ...state,
      profile: action.profile,
      formErrors
    };
  }),
  on(updateProfileForm, (state, action) => {
    return returnProfileReduced(state, action);
  }),
  on(updateProfileBCIForm, (state, action) => {
    return returnProfileReduced(state, action);
  }),

  on(updateProfileCBSForm, (state, action) => {
    return returnProfileReduced(state, action);
  }),
  on(updateProfilePRISMForm, (state, action) => {
    return returnProfileReduced(state, action);
  }),

  on(updateProfileI9Form, (state, action) => {
    return returnProfileReduced(state, action);
  }),
  on(updateProfileW4Form, (state, action) => {
    return returnProfileReduced(state, action);
  }),
  on(saveProfile, (state, action) => ({ ...state, savingProfile: true })),
  on(saveProfileSuccess, (state, action) => ({ ...state, profile: action.profile, savingProfile: false })),
  on(saveProfileFail, (state, action) => ({ ...state, savingProfile: false })),
  on(getPhotoSuccess, (state, action) => ({ ...state, ...{ photoUrl: action.url } })),

  on(uploadPhoto, (state, action) => ({ ...state, ...{ uploadingPhoto: true } })),
  on(uploadPhotoSuccess, (state, action) => ({ ...state, ...{ uploadingPhoto: false } })),
  on(changePassword, (state, action) => ({ ...state, ...{ changingPassword: true } })),
  on(changePasswordSuccess, (state, action) => ({ ...state, ...{ changingPassword: false } })),

  on(loadSpokenLanguageOptionsSuccess, (state, action) => {
    return {
      ...state,
      spokenLanguageOptions: action.spokenLanguageOptions
    };
  }),

  on(loadRaceOptionsSuccess, (state, action) => {
    return {
      ...state,
      raceOptions: action.raceOptions
    };
  }),
  on(getReturnEquipmentAlertsSuccess, (state, action) => {
    return {
      ...state,
      returnEquipmentAlert: action.alert.alert,
      returnEquipmentAlertCount: action.alert.count,
      returnEquipmentAlertAllCount: action.alert.allCount,
    };
  }),
  on(loadJobTitlesSuccess, (state, action) => {
    return {
      ...state,
      jobTitles: action.jobTitles
    };
  }),

  on(loadUserTypesSuccess, (state, action) => {
    return {
      ...state,
      userTypes: action.userTypes
    };
  }),

  on(loadProfileOptionsSuccess, (state, action) => {
    return {
      ...state,
      maritalStatusOptions: action.profileOptions.maritalStatusOptions,
      statutoryClassOptions: action.profileOptions.statutoryClassOptions,
      eeoJobCategoryOptions: action.profileOptions.eeoJobCategoryOptions,
      acaClassificationOptions: action.profileOptions.acaClassificationOptions,
    };
  }),

  on(saveSignature, (state, action) => ({ ...state, savingSignature: true })),
  on(saveSignatureSuccess, (state, action) => ({ ...state, savingSignature: false })),
  on(saveSignatureFailure, (state, action) => ({ ...state, savingSignature: false })),
  on(saveUserSignature, (state, action) => ({ ...state, savingSignature: true })),
  on(saveUserSignatureSuccess, (state, action) => ({ ...state, savingSignature: false })),
  on(saveUserSignatureFailure, (state, action) => ({ ...state, savingSignature: false })),

);

function returnProfileReduced(state, action) {
  const newUser = { ...state.profile.user, ...action.userValues };
  const newEmployee = { ...state.profile.employee, ...action.employeeValues };
  const newEmployeeFederalTaxInformation = { ...state.profile.employeeFederalTaxInformation, ...action.employeeFederalTaxInformationValues };
  const newProfile = { ...state.profile, ...{ user: newUser, employee: newEmployee , employeeFederalTaxInformation: newEmployeeFederalTaxInformation } };
  const newState = { ...state, ...{ profile: newProfile, formErrors: action.formErrors } };
  return newState;
}

export function profileReducerFunc(state: ProfileState | undefined, action: Action) {
  return profileReducer(state, action);
}


export function initProfileForm(profile: UserProfileModel, fb: UntypedFormBuilder) {

  const fbForm = fb.group({
    userId: fb.control(profile.userId),
    user: fb.group({
      email: fb.control(profile.user.email, [Validators.maxLength(255), Validators.email]),
      phoneNumber: fb.control(formatPhoneNumber(profile.user.phoneNumber),
        [Validators.required, Validators.maxLength(255),
          Validators.pattern('^[+]{0,1}[0-9]{0,4}[( ]{0,2}[0-9]{3,4}[-) ]{0,2}[0-9]{3,4}[-]{0,1}[0-9]{4,5}$')]),
      firstName: fb.control(profile.user.firstName),
      lastName: fb.control(profile.user.lastName),
      preferedName: fb.control(profile.user.preferedName, [Validators.maxLength(255)]),
      middleName: fb.control(profile.user.middleName, [Validators.maxLength(255)]),
      previousName: fb.control(profile.user.previousName, [Validators.maxLength(255)]),
      doAllowEmailNotifications: fb.control(profile.user.doAllowEmailNotifications),
      doAllowSMSNotifications: fb.control(profile.user.doAllowSMSNotifications),
      noOtherLanguages: fb.control(profile.user.noOtherLanguages),
      inactive: fb.control(profile.user.inactive),
      primaryProgramID: fb.control(profile.user.primaryProgramID),
      usersWhy: fb.control(profile.user.usersWhy)
    }),
    employee: fb.group({
      backgroundCheckConfirmationDate: fb.control(profile.employee.backgroundCheckConfirmationDate),
      birthdate: fb.control(profile.employee.birthdate),
      hasTimeCard: fb.control(profile.employee.hasTimeCard),
      inTraining: fb.control(profile.employee.inTraining),
      payrollClassificationID: fb.control(profile.employee.payrollClassificationID),
      payrollEmployeeNumber: fb.control(profile.employee.payrollEmployeeNumber),
      stateOfBirth: fb.control(profile.employee.stateOfBirth, [Validators.required]),
      terminationDate: fb.control(profile.employee.terminationDate),
      trainingStartDate: fb.control(profile.employee.trainingStartDate),

      address: fb.control(profile.employee.address, [Validators.required, Validators.maxLength(255)]),
      addressExtra: fb.control(profile.employee.addressExtra, [Validators.maxLength(255)]),
      city: fb.control(profile.employee.city, [Validators.required, Validators.maxLength(255)]),
      state: fb.control(profile.employee.state, [Validators.required, Validators.maxLength(255)]),
      zipCode: fb.control(profile.employee.zipCode,
        [Validators.required, Validators.maxLength(255), Validators.pattern('^([0-9]{5,10}|[0-9]{3,5}-[0-9]{3,5})$')]),
      mailingAddress: fb.control(profile.employee.mailingAddress, [Validators.required, Validators.maxLength(255)]),
      mailingAddressExtra: fb.control(profile.employee.mailingAddressExtra, [Validators.maxLength(255)]),
      mailingCity: fb.control(profile.employee.mailingCity, [Validators.required, Validators.maxLength(255)]),
      mailingState: fb.control(profile.employee.mailingState, [Validators.required, Validators.maxLength(255)]),
      mailingZipCode: fb.control(profile.employee.mailingZipCode, [Validators.required, Validators.maxLength(255)]),
      tShirtSize: fb.control(profile.employee.tShirtSize, [Validators.required, Validators.maxLength(20)]),
      pantSize: fb.control(profile.employee.pantSize, [Validators.required, Validators.maxLength(20)]),
      emergencyContactName: fb.control(profile.employee.emergencyContactName, [Validators.required, Validators.maxLength(255)]),
      emergencyContactPhone: fb.control(profile.employee.emergencyContactPhone,
        [Validators.required, Validators.maxLength(255), ,
        Validators.pattern('^[+]{0,1}[0-9]{0,4}[( ]{0,2}[0-9]{3,4}[-) ]{0,2}[0-9]{3,4}[-]{0,1}[0-9]{4,5}$')]),
      emergencyContactRelation: fb.control(profile.employee.emergencyContactRelation,
        [Validators.required, Validators.maxLength(255)]),
      emergencyContact2Name: fb.control(profile.employee.emergencyContact2Name, [Validators.maxLength(255)]),
      emergencyContact2Phone: fb.control(profile.employee.emergencyContact2Phone, [Validators.maxLength(255),
      Validators.pattern('^[+]{0,1}[0-9]{0,4}[( ]{0,2}[0-9]{3,4}[-) ]{0,2}[0-9]{3,4}[-]{0,1}[0-9]{4,5}$')]),
      emergencyContact2Relation: fb.control(profile.employee.emergencyContact2Relation, [Validators.maxLength(255)]),
      ssn: fb.control(profile.employee.ssn),
      bankName: fb.control(profile.employee.bankName, [Validators.maxLength(255)]),
      bankAccountNumber: fb.control(profile.employee.bankAccountNumber, [Validators.maxLength(255)]),
      bankRoutingNumber: fb.control(profile.employee.bankRoutingNumber, [Validators.maxLength(255)]),
      bankAccountNumberConfirm: fb.control(profile.employee.bankAccountNumber),
      bankRoutingNumberConfirm: fb.control(profile.employee.bankRoutingNumber),
      bankAccountType: fb.control(profile.employee.bankAccountType, [Validators.maxLength(255)]),
      personalEmail: fb.control(profile.employee.personalEmail, [Validators.required, Validators.maxLength(255), Validators.email]),

      bciNewRenewTransfer: fb.control(profile.employee.bciNewRenewTransfer),
      bciBeenArrested: fb.control(profile.employee.bciBeenArrested),
      bciBeenInvestigated: fb.control(profile.employee.bciBeenInvestigated),
      bciLiveScanCompleted: fb.control(profile.employee.bciLiveScanCompleted),
      bciTCN: fb.control(profile.employee.bciTCN),
      bciIsYouthResidential: fb.control(profile.employee.bciIsYouthResidential),
      bciLivedOutside: fb.control(profile.employee.bciLivedOutside,
        profile.isOnBoarding ? [Validators.required] : []),
      bciLivedOutsideCertify: fb.control(profile.employee.bciLivedOutsideCertify),
      bciLivedOutsideList: fb.control(profile.employee.bciLivedOutsideList, [Validators.maxLength(2000)]),

      cbsApplicationNumber: fb.control(profile.employee.cbsApplicationNumber),
      prismRequestDate: fb.control(profile.employee.prismRequestDate),
      prismEffectiveDate: fb.control(profile.employee.prismEffectiveDate),

      i9USSituation: fb.control(profile.employee.i9USSituation),
      i9USCIS: fb.control(profile.employee.i9USCIS),
      i9AlienAuthorizationExpirationDate: fb.control(profile.employee.i9AlienAuthorizationExpirationDate),
      i9i94AdmissionNumber: fb.control(profile.employee.i9i94AdmissionNumber),
      i9ForeignPassportNumber: fb.control(profile.employee.i9ForeignPassportNumber),
      i9ForeignPassportCountry: fb.control(profile.employee.i9ForeignPassportCountry),
      i9UsedPreparer: fb.control(profile.employee.i9UsedPreparer),

      hasDisability: fb.control(profile.employee.hasDisability, [Validators.required]),
      veteranStatus: fb.control(profile.employee.veteranStatus, [Validators.required]),
      raceEthnicityID: fb.control(profile.employee.raceEthnicityID, [Validators.required]),
      genderAtBirth: fb.control(profile.employee.genderAtBirth, [Validators.required]),
      differentGenderIdentity: fb.control(profile.employee.differentGenderIdentity),
      preferredGenderIdentity: fb.control(profile.employee.preferredGenderIdentity, [Validators.maxLength(255)]),
      customPronouns: fb.control(profile.employee.customPronouns, [Validators.maxLength(255)]),

      bciIDType: fb.control(profile.employee.bciIDType),
      bciIDState: fb.control(profile.employee.bciIDState),
      bciIDNumber: fb.control(profile.employee.bciIDNumber),
      bciIDExpirationDate: fb.control(profile.employee.bciIDExpirationDate),

      bciGender: fb.control(profile.employee.bciGender),
      bciRace: fb.control(profile.employee.bciRace),
      bciEyeColor: fb.control(profile.employee.bciEyeColor),
      bciHairColor: fb.control(profile.employee.bciHairColor),
      bciWeight: fb.control(profile.employee.bciWeight),
      bciHeight: fb.control(profile.employee.bciHeight),
      bciLicenseTypes: fb.control(profile.employee.bciLicenseTypes),
      bciProgramName: fb.control(profile.employee.bciProgramName),
      bciSiteNameOrAddress: fb.control(profile.employee.bciSiteNameOrAddress),
      bciProgramPhoneNumber: fb.control(profile.employee.bciProgramPhoneNumber),
      i9AdditionalInfo: fb.control(profile.employee.i9AdditionalInfo),
      i9EmploymentFirstDate: fb.control(profile.employee.i9EmploymentFirstDate),
      i9OrganizationName: fb.control(profile.employee.i9OrganizationName),
      i9OrganizationAddress: fb.control(profile.employee.i9OrganizationAddress),
      i9OrganizationCity: fb.control(profile.employee.i9OrganizationCity),
      i9OrganizationState: fb.control(profile.employee.i9OrganizationState),
      i9OrganizationZIP: fb.control(profile.employee.i9OrganizationZIP),
      i9NewFirstName: fb.control(profile.employee.i9NewFirstName),
      i9NewLastName: fb.control(profile.employee.i9NewLastName),
      i9NewMiddleInitial: fb.control(profile.employee.i9NewMiddleInitial),
      i9RehireDate: fb.control(profile.employee.i9RehireDate),
      i9RehireDocumentTitle: fb.control(profile.employee.i9RehireDocumentTitle),
      i9RehireDocumentNumber: fb.control(profile.employee.i9RehireDocumentNumber),
      i9RehireExpirationDate: fb.control(profile.employee.i9RehireExpirationDate),


      orientationDate: fb.control(profile.employee.orientationDate ? new Date(profile.employee.orientationDate) : null),
      i9CompletionDate: fb.control(profile.employee.i9CompletionDate ? new Date(profile.employee.i9CompletionDate) : null),
      eVerifyCompletionDate: fb.control(profile.employee.eVerifyCompletionDate ? new Date(profile.employee.eVerifyCompletionDate) : null),

      suffix: fb.control(profile.employee.suffix),
      department: fb.control(profile.employee.department),
      county: fb.control(profile.employee.county),
      country: fb.control(profile.employee.country),
      mailingCounty: fb.control(profile.employee.mailingCounty),
      mailingCountry: fb.control(profile.employee.mailingCountry),
      tobaccoUser: fb.control(profile.employee.tobaccoUser, [Validators.required]),
      statutoryClassID: fb.control(profile.employee.statutoryClassID),
      eeoJobCategoryID: fb.control(profile.employee.eeoJobCategoryID),
      maritalStatusID: fb.control(profile.employee.maritalStatusID),
      acaClassificationID: fb.control(profile.employee.acaClassificationID),

      preparerFirstname: fb.control(profile.employee.preparerFirstname),
      preparerLastname: fb.control(profile.employee.preparerLastname),
      preparerAddress: fb.control(profile.employee.preparerAddress),
      preparerCity: fb.control(profile.employee.preparerCity),
      preparerState: fb.control(profile.employee.preparerState),
      preparerZip: fb.control(profile.employee.preparerZip),

      i9ListA1DocumentNumber: fb.control(profile.employee.i9ListA1DocumentNumber),
      i9ListA1DocumentTitle: fb.control(profile.employee.i9ListA1DocumentTitle),
      i9ListA1ExpirationDate: fb.control(profile.employee.i9ListA1ExpirationDate),
      i9ListA1IssuingAuthority: fb.control(profile.employee.i9ListA1IssuingAuthority),

      i9ListA2DocumentNumber: fb.control(profile.employee.i9ListA2DocumentNumber),
      i9ListA2DocumentTitle: fb.control(profile.employee.i9ListA2DocumentTitle),
      i9ListA2ExpirationDate: fb.control(profile.employee.i9ListA2ExpirationDate),
      i9ListA2IssuingAuthority: fb.control(profile.employee.i9ListA2IssuingAuthority),

      i9ListA3DocumentNumber: fb.control(profile.employee.i9ListA3DocumentNumber),
      i9ListA3DocumentTitle: fb.control(profile.employee.i9ListA3DocumentTitle),
      i9ListA3ExpirationDate: fb.control(profile.employee.i9ListA3ExpirationDate),
      i9ListA3IssuingAuthority: fb.control(profile.employee.i9ListA3IssuingAuthority),

      i9ListBDocumentNumber: fb.control(profile.employee.i9ListBDocumentNumber),
      i9ListBDocumentTitle: fb.control(profile.employee.i9ListBDocumentTitle),
      i9ListBExpirationDate: fb.control(profile.employee.i9ListBExpirationDate),
      i9ListBIssuingAuthority: fb.control(profile.employee.i9ListBIssuingAuthority),

      i9ListCDocumentNumber: fb.control(profile.employee.i9ListCDocumentNumber),
      i9ListCDocumentTitle: fb.control(profile.employee.i9ListCDocumentTitle),
      i9ListCExpirationDate: fb.control(profile.employee.i9ListCExpirationDate),
      i9ListCIssuingAuthority: fb.control(profile.employee.i9ListCIssuingAuthority),

    }, {
      validators: [ValidatorConfirmField('bankAccountNumberConfirm', 'bankAccountNumber'),
      ValidatorConfirmField('bankRoutingNumberConfirm', 'bankRoutingNumber'),
      ...(profile.isOnBoarding ? [ValidatorRequiredNotEmptyIfBool('bciLivedOutsideList', 'bciLivedOutside')] : [])]
    }),
    otherLanguages: fb.array([]),    
  },
    {
      validators: [ValidatorRequiredArrayNotEmptyOrTrue('otherLanguages', ['spokenLanguageId'], 'user.noOtherLanguages')]
    });

  if (profile.otherLanguages != null && profile.otherLanguages.length > 0) {
    profile.otherLanguages.forEach(x => {
      let otherLanguages = fbForm.get('otherLanguages') as UntypedFormArray;
      otherLanguages.push(fb.group({
        id: fb.control(x.id),
        spokenLanguageId: fb.control(x.spokenLanguageId),
        moreInfo: fb.control(x.moreInfo),        
      }))
    });
  }

  return fbForm;
}


export function initProfileBCIForm(profile: UserProfileModel) {
  const form = new UntypedFormGroup({
    user: new UntypedFormGroup({
      middleName: new UntypedFormControl(profile.user.middleName, [Validators.maxLength(255)]),
      previousName: new UntypedFormControl(profile.user.previousName, [Validators.maxLength(255)]),
    }),
    employee: new UntypedFormGroup({
      personalEmail: new UntypedFormControl(profile.employee.personalEmail, [Validators.required, Validators.maxLength(255)]),
      address: new UntypedFormControl(profile.employee.address, [Validators.required, Validators.maxLength(255)]),
      addressExtra: new UntypedFormControl(profile.employee.addressExtra, [Validators.maxLength(255)]),
      city: new UntypedFormControl(profile.employee.city, [Validators.required, Validators.maxLength(255)]),
      state: new UntypedFormControl(profile.employee.state, [Validators.required, Validators.maxLength(255)]),
      zipCode: new UntypedFormControl(profile.employee.zipCode,
        [Validators.required, Validators.maxLength(255), Validators.pattern('^([0-9]{5,10}|[0-9]{3,5}-[0-9]{3,5})$')]),
      birthdate: new UntypedFormControl(profile.employee.birthdate, [Validators.required]),
      ssn: new UntypedFormControl(profile.employee.ssn, [Validators.maxLength(255)]),
      bciNewRenewTransfer: new UntypedFormControl(profile.employee.bciNewRenewTransfer, [Validators.required]),
      bciBeenArrested: new UntypedFormControl(profile.employee.bciBeenArrested, [Validators.required]),
      bciBeenInvestigated: new UntypedFormControl(profile.employee.bciBeenInvestigated, [Validators.required]),
      bciLiveScanCompleted: new UntypedFormControl(profile.employee.bciLiveScanCompleted, [Validators.required]),
      bciTCN: new UntypedFormControl(profile.employee.bciTCN, [Validators.maxLength(255)]),
      bciIsYouthResidential: new UntypedFormControl(profile.employee.bciIsYouthResidential, [Validators.required]),
      bciLivedOutside: new UntypedFormControl(profile.employee.bciLivedOutside),
      bciLivedOutsideCertify: new UntypedFormControl(profile.employee.bciLivedOutsideCertify),
      bciLivedOutsideList: new UntypedFormControl(profile.employee.bciLivedOutsideList,
        [Validators.maxLength(2000)]),

    }, {
      validators: [ValidatorRequiredIfBool('bciLivedOutside', 'bciIsYouthResidential'),
      ValidatorRequiredTrueIfBool('bciLivedOutsideCertify', 'bciLivedOutside'),
      ValidatorRequiredNotEmptyIfBool('bciLivedOutsideList', 'bciLivedOutside')
      ]
    })
  });

  return form;
}


export function initProfileCBSForm(profile: UserProfileModel) {
  const form = new UntypedFormGroup({
    employee: new UntypedFormGroup({
      cbsApplicationNumber: new UntypedFormControl(profile.employee.cbsApplicationNumber, [Validators.pattern(/^[0-9]\d*$/)]),
    })
  });

  return form;
}

export function initProfilePRISMForm(profile: UserProfileModel) {
  const form = new UntypedFormGroup({
    employee: new UntypedFormGroup({
      prismRequestDate: new UntypedFormControl(profile.employee.prismRequestDate, [Validators.required]),
      prismEffectiveDate: new UntypedFormControl(profile.employee.prismEffectiveDate, [Validators.required]),
    })
  });

  return form;
}



export function initProfileI9Form(profile: UserProfileModel) {
  const form = new UntypedFormGroup({
    user: new UntypedFormGroup({
      phoneNumber: new UntypedFormControl(formatPhoneNumber(profile.user.phoneNumber),
        [Validators.required, Validators.maxLength(255),
        Validators.pattern('^[+]{0,1}[0-9]{0,4}[( ]{0,2}[0-9]{3,4}[-) ]{0,2}[0-9]{3,4}[-]{0,1}[0-9]{4,5}$')]),

      middleName: new UntypedFormControl(profile.user.middleName, [Validators.maxLength(255)]),
      previousName: new UntypedFormControl(profile.user.previousName, [Validators.maxLength(255)]),
    }),
    employee: new UntypedFormGroup({
      address: new UntypedFormControl(profile.employee.address, [Validators.required, Validators.maxLength(255)]),
      addressExtra: new UntypedFormControl(profile.employee.addressExtra, [Validators.maxLength(255)]),
      city: new UntypedFormControl(profile.employee.city, [Validators.required, Validators.maxLength(255)]),
      state: new UntypedFormControl(profile.employee.state, [Validators.required, Validators.maxLength(255)]),
      zipCode: new UntypedFormControl(profile.employee.zipCode,
        [Validators.required, Validators.maxLength(255), Validators.pattern('^([0-9]{5,10}|[0-9]{3,5}-[0-9]{3,5})$')]),
      birthdate: new UntypedFormControl(profile.employee.birthdate, [Validators.required]),
      ssn: new UntypedFormControl(profile.employee.ssn, [Validators.maxLength(255)]),
      i9USSituation: new UntypedFormControl(profile.employee.i9USSituation, [Validators.required]),
      i9USCIS: new UntypedFormControl(profile.employee.i9USCIS),
      i9AlienAuthorizationExpirationDate: new UntypedFormControl((profile.employee.i9AlienAuthorizationExpirationDate
        ? new Date(profile.employee.i9AlienAuthorizationExpirationDate).toISOString().substr(0, 10)
        : null)),
      i9i94AdmissionNumber: new UntypedFormControl(profile.employee.i9i94AdmissionNumber),
      i9ForeignPassportNumber: new UntypedFormControl(profile.employee.i9ForeignPassportNumber),
      i9ForeignPassportCountry: new UntypedFormControl(profile.employee.i9ForeignPassportCountry),
      i9UsedPreparer: new UntypedFormControl(profile.employee.i9UsedPreparer, [Validators.required]),
      personalEmail: new UntypedFormControl(profile.employee.personalEmail),
      preparerFirstname: new UntypedFormControl(profile.employee.preparerFirstname, [Validators.maxLength(255)]),
      preparerLastname: new UntypedFormControl(profile.employee.preparerLastname, [Validators.maxLength(255)]),
      preparerAddress: new UntypedFormControl(profile.employee.preparerAddress, [Validators.maxLength(255)]),
      preparerCity: new UntypedFormControl(profile.employee.preparerCity, [Validators.maxLength(255)]),
      preparerState: new UntypedFormControl(profile.employee.preparerState, [Validators.maxLength(255)]),
      preparerZip: new UntypedFormControl(profile.employee.preparerZip, [Validators.maxLength(10)]),
    }, { validators: [i9Validator()] }
    )
  });

  return form;
}

export function i9Validator(): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (form.get('i9USSituation').value === 'PermanentResident') {
      if (!form.get('i9USCIS').value) {
        form.get('i9USCIS').setErrors({ required: { value: form.get('i9USCIS').value } });
        return { required: { value: form.get('i9USCIS').value } };
      } else {
        form.get('i9USCIS').setErrors(null);
      }
    } else if (form.get('i9USSituation').value === 'AuthorizedToWork') {
      if (
        (form.get('i9USCIS').value
          && (form.get('i9i94AdmissionNumber').value
            || form.get('i9ForeignPassportNumber').value
            || form.get('i9ForeignPassportCountry').value)
        )
        ||
        (form.get('i9i94AdmissionNumber').value
          && (form.get('i9USCIS').value
            || form.get('i9ForeignPassportNumber').value
            || form.get('i9ForeignPassportCountry').value)
        )
      ) {
        form.get('i9USCIS').setErrors({ genericMessage: 'Fill ONLY one of the fields. Alien Registration Number/USCIS Number OR Form I-94 Admission Number OR Foreign Passport Number' });
        return { genericMessage: 'Fill only one of the fields. Alien Registration Number/USCIS Number OR Form I-94 Admission Number OR Foreign Passport Number' };
      } else if (
        (!form.get('i9USCIS').value
          && !form.get('i9i94AdmissionNumber').value
          && !form.get('i9ForeignPassportNumber').value)
      ) {
        form.get('i9USCIS').setErrors({ genericMessage: 'Fill AT LEAST one of the fields: Alien Registration Number/USCIS Number OR Form I-94 Admission Number OR Foreign Passport Number' });
        return { genericMessage: 'Fill at least one  of the fields. Alien Registration Number/USCIS Number OR Form I-94 Admission Number OR Foreign Passport Number' };
      } else {
        form.get('i9USCIS').setErrors(null);
      }

      if (form.get('i9ForeignPassportNumber').value
        && !form.get('i9ForeignPassportCountry').value) {
        form.get('i9ForeignPassportCountry').setErrors({ genericMessage: 'Country is required if you filled Foreign Passport Number' });
        return { genericMessage: 'Country is required if you filled Foreign Passport Number' };
      } else {
        form.get('i9ForeignPassportCountry').setErrors(null);
      }
    }
    else {
      form.get('i9USCIS').setErrors(null);
      form.get('i9ForeignPassportCountry').setErrors(null);
    }

    if (form.get('i9UsedPreparer').value) {
      if (!form.get('preparerFirstname').value) {
        form.get('preparerFirstname').setErrors({ required: { value: form.get('preparerFirstname').value } });
      } else {
        form.get('preparerFirstname').setErrors(null);
      }
      if (!form.get('preparerLastname').value) {
        form.get('preparerLastname').setErrors({ required: { value: form.get('preparerLastname').value } });
      } else {
        form.get('preparerLastname').setErrors(null);
      }
      if (!form.get('preparerAddress').value) {
        form.get('preparerAddress').setErrors({ required: { value: form.get('preparerAddress').value } });
      } else {
        form.get('preparerAddress').setErrors(null);
      }
      if (!form.get('preparerCity').value) {
        form.get('preparerCity').setErrors({ required: { value: form.get('preparerCity').value } });
      } else {
        form.get('preparerCity').setErrors(null);
      }
      if (!form.get('preparerState').value) {
        form.get('preparerState').setErrors({ required: { value: form.get('preparerState').value } });
      } else {
        form.get('preparerState').setErrors(null);
      }
      if (!form.get('preparerZip').value) {
        form.get('preparerZip').setErrors({ required: { value: form.get('preparerZip').value } });
      } else {
        form.get('preparerZip').setErrors(null);
      }

    } else {
      if (form.get('preparerFirstname')) {
        form.get('preparerFirstname').setErrors(null);
      }
      if (form.get('preparerLastname')) {
        form.get('preparerLastname').setErrors(null);
      }
      if (form.get('preparerAddress')) {
        form.get('preparerAddress').setErrors(null);
      }
      if (form.get('preparerCity')) {
        form.get('preparerCity').setErrors(null);
      }
      if (form.get('preparerState')) {
        form.get('preparerState').setErrors(null);
      }
      if (form.get('preparerZip')) {
        form.get('preparerZip').setErrors(null);
      }
    }
  };
}




export function initProfileW4Form(profile: UserProfileModel) {
  const form = new UntypedFormGroup({
    user: new UntypedFormGroup({
      firstName: new UntypedFormControl(profile.user.firstName, [Validators.maxLength(255)]),
      middleName: new UntypedFormControl(profile.user.middleName, [Validators.maxLength(255)]),
      lastName: new UntypedFormControl(profile.user.lastName, [Validators.maxLength(255)]),
    }),
    employee: new UntypedFormGroup({
      ssn: new UntypedFormControl(profile.employee.ssn, [Validators.maxLength(255)]),
      address: new UntypedFormControl(profile.employee.address, [Validators.required, Validators.maxLength(255)]),
      addressExtra: new UntypedFormControl(profile.employee.addressExtra, [Validators.maxLength(255)]),
      city: new UntypedFormControl(profile.employee.city, [Validators.required, Validators.maxLength(255)]),
      state: new UntypedFormControl(profile.employee.state, [Validators.required, Validators.maxLength(255)]),
      zipCode: new UntypedFormControl(profile.employee.zipCode, [Validators.required, Validators.maxLength(255), Validators.pattern('^([0-9]{5,10}|[0-9]{3,5}-[0-9]{3,5})$')])
    }),
    employeeFederalTaxInformation: new UntypedFormGroup({
      filingStatus: new UntypedFormControl(profile.employeeFederalTaxInformation.filingStatus, [Validators.required]),
      higherRate: new UntypedFormControl(profile.employeeFederalTaxInformation.higherRate, [Validators.required]),
      childDependentsAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.childDependentsAmount, [Validators.maxLength(12), Validators.pattern('^([0-9]*)$')]),
      otherDependentsAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.otherDependentsAmount, [Validators.maxLength(12), Validators.pattern('^([0-9]*)$')]),
      totalDependentsAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.totalDependentsAmount, [Validators.maxLength(12), Validators.pattern('^([0-9]*)$')]),
      otherIncomeAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.otherIncomeAmount, [Validators.maxLength(12), Validators.pattern('^((-?[0-9]+)|(-?[0-9]+[.][0-9]{1,2}))?$')]),
      deductionsAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.deductionsAmount, [Validators.maxLength(12), Validators.pattern('^((-?[0-9]+)|(-?[0-9]+[.][0-9]{1,2}))?$')]),
      extraWithholdingAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.extraWithholdingAmount, [Validators.maxLength(12), Validators.pattern('^((-?[0-9]+)|(-?[0-9]+[.][0-9]{1,2}))?$')]),
      extraStateWithholdingAmount: new UntypedFormControl(profile.employeeFederalTaxInformation.extraStateWithholdingAmount, [Validators.maxLength(12), Validators.pattern('^((-?[0-9]+)|(-?[0-9]+[.][0-9]{1,2}))?$')]),
    }, { validators: [W4Validator()] }
    )
  });

  return form;
}

export function W4Validator(): ValidatorFn {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (form.get('childDependentsAmount').value && !form.get('childDependentsAmount').errors) {
      var vl = parseFloat(form.get('childDependentsAmount').value);
      if (!isNaN(vl) && vl % 2000 != 0) {
        form.get('childDependentsAmount').setErrors({ genericMessage: 'Child Dependents Amount must be a multiple of 2000.' });
        return { genericMessage: 'Child Dependents Amount must be a multiple of 2000.' };
      }
    }
    if (form.get('otherDependentsAmount').value && !form.get('otherDependentsAmount').errors) {
      var vl = parseFloat(form.get('otherDependentsAmount').value);
      if (!isNaN(vl) && vl % 500 != 0) {
        form.get('otherDependentsAmount').setErrors({ genericMessage: 'Other Dependents Amount must be a multiple of 500.' });
        return { genericMessage: 'Other Dependents Amount must be a multiple of 500.' };
      }
    }

    if (form.get('otherDependentsAmount').value && !form.get('otherDependentsAmount').errors
      && form.get('childDependentsAmount').value && !form.get('childDependentsAmount').errors
      && form.get('totalDependentsAmount').value && !form.get('totalDependentsAmount').errors    ) {
      var vl = parseFloat(form.get('totalDependentsAmount').value);
      var vl2 = parseFloat(form.get('otherDependentsAmount').value) + parseFloat(form.get('childDependentsAmount').value);
      if (!isNaN(vl) && vl != vl2) {
        form.get('totalDependentsAmount').setErrors({ genericMessage: 'Total Dependents Amount must be the sum of child and other dependents amount.' });
        return { genericMessage: 'Total Dependents Amount must be the sum of child and other dependents amount.' };
      }
    }
  };
}


